{
  "manual": "Manual ({number, number})",
  "automatic": "Automatic",
  "payment_methods": {
    "payment_by_invoice": "Invoice",
    "payment_on_account": "On account",
    "upfront_payment": "Upfront",
    "quote": "Quote"
  }
}
